import ItemDescription from "../core/ItemDescription.tsx";
import ItemImages from "../core/ItemImages.tsx";
import ItemPrice from "../core/ItemPrice.tsx";
import {
  IconCalendar,
  IconCategory,
  IconEyeQuestion,
  IconHeart,
  IconHeartFilled,
  IconMessage2Plus,
  IconPhotoX,
  IconTag,
  IconTypography,
} from "@tabler/icons-react";
import InfoElem from "../../core/InfoElem";
import ItemTitle from "../core/ItemTitle";
import ItemAttributeTable from "./ItemAttributeTable";
import ItemDate from "../core/ItemDate";
import { SubmitProvider } from "../../../context/context.submit";
import ItemOwner from "../core/ItemOwner";
import UserImage from "../../user/core/UserImage";
import { useItem } from "../../../fetch/fetch.item";
import { EMPTY_ITEM } from "../../../const/typeDefault/Item";
import ErrMessage from "../../core/ErrMessage";
import { openModal } from "../../core/PopUp";
import Authorized from "../../core/auth/Authorized";
import IfItemOwner from "../coditions/IfItemOwner.tsx";
import SetStatus from "../core/SetStatus";
import ItemStatus from "../core/ItemStatus";
import ContactUser from "../../chat/core/ContactUser.tsx";
import { MODAL_LOGIN_ID } from "../../login/LoginModal.tsx";
import FavoriteItem from "../core/FaveoriteItem.tsx";
import ItemCategory from "../core/ItemCategory.tsx";
import ShareButton from "../../core/ShareButton.tsx";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ROUTE_PROFILE } from "../../../const/routes.ts";

function ItemOwnerImage(props: { itemId: string }) {
  const { item, isLoading, isError } = useItem(props.itemId, EMPTY_ITEM);
  if (isError) return <ErrMessage message={isError} />;
  if (isLoading)
    return (
      <div className="skeleton w-8 h-auto aspect-square rounded-full"></div>
    );
  return (
    <UserImage
      userId={item.ownerId}
      className="w-8 h-auto aspect-square rounded-full"
    />
  );
}

const OwnerLink = ({
  children,
  itemId,
}: {
  children: ReactNode;
  itemId: string;
}) => {
  const { item } = useItem(itemId, EMPTY_ITEM);
  return (
    <Link to={ROUTE_PROFILE(item.ownerId)} className="link">
      {children}
    </Link>
  );
};

const ItemShare = ({ itemId }: { itemId: string }) => {
  const { item } = useItem(itemId, EMPTY_ITEM);
  return <ShareButton url={window.location.href} title={item.title} />;
};
const ItemView = ({ itemId }: { itemId: string }) => {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-2">
      <div className="xl:col-span-2 md:p-2 bg-base-200 p-1 rounded-xl">
        <ItemImages
          id={itemId}
          fallback={
            <span className="flex gap-2">
              <IconPhotoX /> Diese Anzeige hat keine Bilder.
            </span>
          }
        />
      </div>
      <div className="grid xl:col-span-2 grid-cols-2 gap-2">
        <SubmitProvider>
          <Authorized
            ifUnauthorized={
              <button
                className="btn rounded-full"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  openModal(MODAL_LOGIN_ID);
                }}
              >
                <IconHeart />
                Zu Favoriten
              </button>
            }
          >
            <FavoriteItem
              itemId={itemId}
              className="rounded-full"
              favoriteActiveChildren={
                <>
                  <IconHeartFilled />
                  Favorisiert
                </>
              }
              favoriteInactiveChildren={
                <>
                  <IconHeart />
                  Zu Favoriten
                </>
              }
            />
          </Authorized>
        </SubmitProvider>
        <ItemShare itemId={itemId} />
      </div>
      <div className="xl:col-span-2">
        <InfoElem icon={<IconEyeQuestion />} heading="Sichtbarkeit">
          <div className="flex">
            <IfItemOwner itemId={itemId} fallback={<ItemStatus id={itemId} />}>
              <SubmitProvider>
                <SetStatus itemId={itemId} />
                <button
                  className="btn active:btn-info btn-accent"
                  onClick={(e) => {
                    e.stopPropagation();
                    openModal(`item-setting`);
                  }}
                >
                  <ItemStatus id={itemId} />
                </button>
              </SubmitProvider>
            </IfItemOwner>
          </div>
        </InfoElem>
      </div>
      <div className="xl:col-span-2">
        <InfoElem
          icon={<IconTypography />}
          heading={
            <h1>
              <ItemTitle id={itemId} />
            </h1>
          }
        >
          <article className="text-xl opacity-75 whitespace-pre-line">
            <ItemDescription id={itemId} />
          </article>
        </InfoElem>
      </div>

      <InfoElem icon={<IconTag />} heading="Preis">
        <ItemPrice id={itemId} />
      </InfoElem>
      <InfoElem icon={<IconCategory />} heading="Kategorie">
        <ItemCategory id={itemId} />
      </InfoElem>
      <div className="xl:col-span-2 rounded-box bg-base-200">
        <ItemAttributeTable itemId={itemId} />
      </div>
      <InfoElem icon={<IconCalendar />} heading="Veröffentlicht am">
        <ItemDate id={itemId} />
      </InfoElem>
      <div className="flex flex-col gap-2 rounded-field bg-base-200 p-3 ">
        <OwnerLink itemId={itemId}>
          <div className="flex gap-2 text-xl">
            <ItemOwnerImage itemId={itemId} />

            <ItemOwner id={itemId} />
          </div>
        </OwnerLink>
        <div className="flex w-full">
          <Authorized
            ifUnauthorized={
              <button
                className="btn btn-info w-full rounded-full"
                onClick={() => openModal(MODAL_LOGIN_ID)}
              >
                kontaktieren
                <IconMessage2Plus className="opacity-75" stroke={2} />
              </button>
            }
          >
            <ContactUser id={itemId} />
          </Authorized>
        </div>
      </div>
    </div>
  );
};
export default ItemView;
